import http from '../../services/http'

// Registered but currently unused module. The single action below is retained
// for module registration and repointed off the retired legacy PHP backend to
// the Laravel API.
export default {
    state: {
        machines: []
    },

    actions: {
        async getAllMachines({ commit }) {
            const res = await http.get('/api/machines')
            commit('storeMachines', res.data)
        }
    },

    getters: {},

    mutations: {
        storeMachines(state, machines) {
            state.machines = machines
        }
    }
}
